import { FiltersErrors } from '@britishcouncil/react-admin';
import { BaseReportFilterType } from 'types';

export const dateRangeValidate = (values: BaseReportFilterType): FiltersErrors | undefined => {
  if (!values.date?.[0] || !values.date?.[1]) {
    return { date: 'Date range is required' };
  }
  return undefined;
};
